// extracted by mini-css-extract-plugin
export var actions = "_1t-0";
export var actionsContainer = "_1t-7";
export var border = "_1t-1";
export var childFullHeight = "_1t-f";
export var collapse = "_1t-2";
export var content = "_1t-a";
export var contentChild = "_1t-e";
export var fullscreen = "_1t-c";
export var hasLeftRadius = "_1t-k";
export var headerContainer = "_1t-3";
export var headerRow = "_1t-5";
export var hidePadding = "_1t-b";
export var navCollapsedGap = "_1t-l";
export var noScrollX = "_1t-m";
export var noScrollY = "_1t-n";
export var noTopPadding = "_1t-i";
export var optOutTopPadding = "_1t-d";
export var pageMain = "_1t-j";
export var pageOuter = "_1t-g";
export var pagePadding = "_1t-8";
export var pageScroll = "_1t-9";
export var profile = "_1t-o";
export var profileContainer = "_1t-p";
export var profileImage = "_1t-q";
export var profileMain = "_1t-r";
export var profileSubtitle = "_1t-t";
export var profileTitle = "_1t-s";
export var showLeftPadding = "_1t-h";
export var tabsPortalSlot = "_1t-6";
export var tabsWrapper = "_1t-4";
export var title = "_1t-u";